import { useMemo } from "react";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { useLandingTitle } from "../../../common/context/landingTitle";
import { useSelectedFilters } from "../../context/selectedFilters";
import { generateTitle } from "./helpers";

export const useTitle = () => {
  const formatMessage = useFormatMessage();
  const selectedFilters = useSelectedFilters();
  const titleContext = useLandingTitle();

  const title = useMemo(
    () => generateTitle(titleContext, selectedFilters, formatMessage("results.title.preposition")),
    [titleContext, selectedFilters]
  );

  return title;
};
